import { useKeyInSearch } from '@palette/hooks/NavigationHooks';

import { QUERY_FILTER_QS_KEY, QUICK_SEARCH_QS_KEY } from '@palette/constants/resources';

export const useQuickSearchInSearch = () => useKeyInSearch(QUICK_SEARCH_QS_KEY, '');

export const useQueryFilterInSearch = () => useKeyInSearch(QUERY_FILTER_QS_KEY, '');
